"use strict";

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
window.onVariantChangeCallback = function (available, variant, options, optionElements) {
  let sectionId = "";
  if (optionElements.length > 0) {
    let shopifySection = optionElements[0].closest(".shopify-section");
    if (shopifySection) {
      sectionId = shopifySection.id.split("shopify-section-")[1];
    }
  }
  publish(PUB_SUB_EVENTS.variantChange, {
    data: {
      sectionId,
      html: "",
      variant
    }
  });
  function formatUnitPrice(variant) {
    if (!variant.unit_price_measurement) return "";
    return (/* html */`
            <span>
                ${Shopify.formatMoney(variant.unit_price || 0, window.murmel.money_with_currency_format)}
            </span>
            <span aria-hidden="true">
                /
            </span>
            <span class="visually-hidden">
                &nbsp;
                ${window.variantStrings.unitPriceSeparator}
                &nbsp;
            </span>
            <span>
                ${variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value : ""}
                ${variant.unit_price_measurement.reference_unit}
            </span>
        `
    );
  }
  if (variant) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", variant.id);
    window.history.replaceState({}, '', newUrl.toString());
  }
  const pickUpAvailability = document.querySelector('pickup-availability');
  const shareButton = document.getElementById(`Share-${sectionId}`);
  const priceWrapper = document.querySelector(`#price-${sectionId} .price`);
  const priceBadgeSale = document.querySelector(`#price-${sectionId} .js-product-badge-sale`);
  const priceBadgeSoldout = document.querySelector(`#price-${sectionId} .js-product-badge-soldout`);
  const taxWrapper = document.querySelector(`#ProductInfo-${sectionId} .product__tax`);
  const saleOldPrice = document.querySelector(`#price-${sectionId} .price__sale .price-item--old`);
  const addToCartBtn = document.querySelector(`#shopify-section-${sectionId} .js-btn-add-to-cart`);
  const saleNewPrice = document.querySelector(`#price-${sectionId} .price__sale .price-item--sale`);
  const regularPrice = document.querySelector(`#price-${sectionId} .price__regular .price-item--regular`);
  const unitPrice = document.querySelector(`#price-${sectionId} .unit-price .price-item--last`);
  const productMediaThumb = document.querySelector(`#shopify-section-${sectionId} [data-thumbs-media="${variant?.featured_media?.id || "undefined-variant"}"]`);
  const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment-${sectionId}`);
  const compareAtPriceFormatted = Shopify.formatMoney(variant.compare_at_price || 0, window.murmel.money_with_currency_format);
  const unitPriceFormatted = formatUnitPrice(variant);
  const priceFormatted = Shopify.formatMoney(variant.price || 0, window.murmel.money_with_currency_format);
  if (productMediaThumb) {
    setTimeout(function () {
      productMediaThumb.click();
    }, 25);
  }
  if (variant.compare_at_price !== null && variant.price < variant.compare_at_price) {
    // Sale
    priceWrapper.classList.add("price--on-sale");
    saleOldPrice.querySelector("s").innerHTML = compareAtPriceFormatted;
    saleNewPrice.innerHTML = priceFormatted;
  } else {
    // Regular
    priceWrapper.classList.remove("price--on-sale");
    regularPrice.innerHTML = priceFormatted;
  }
  if (unitPrice) {
    unitPrice.innerHTML = unitPriceFormatted;
  }
  if (addToCartBtn) {
    addToCartBtn.disabled = !(variant && available);
    addToCartBtn.querySelector("span").innerHTML = variant ? available ? addToCartBtn.dataset.msgAvailable : addToCartBtn.dataset.msgSoldout : addToCartBtn.dataset.msgUnavailable;
  }
  if (priceBadgeSale && priceBadgeSoldout) {
    if (variant && available) {
      priceBadgeSale.classList.remove("visually-hidden");
      priceBadgeSoldout.classList.add("visually-hidden");
      priceWrapper.classList.remove("visually-hidden");
      taxWrapper && taxWrapper.classList.remove("visually-hidden");
    } else if (!variant && !available) {
      priceBadgeSale.classList.add("visually-hidden");
      priceBadgeSoldout.classList.add("visually-hidden");
      priceWrapper.classList.add("visually-hidden");
      taxWrapper && taxWrapper.classList.add("visually-hidden");
    } else {
      priceBadgeSale.classList.add("visually-hidden");
      priceBadgeSoldout.classList.remove("visually-hidden");
      priceWrapper.classList.remove("visually-hidden");
      taxWrapper && taxWrapper.classList.remove("visually-hidden");
    }
  }
  if (shareButton) {
    shareButton.updateUrl(`${window.shopUrl}${window.murmel.product_url}?variant=${variant.id}`);
  }
  if (pickUpAvailability) {
    if (variant && available) {
      pickUpAvailability.fetchAvailability(variant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  productForms.forEach(productForm => {
    const input = productForm.querySelector('input[name="id"]');
    if (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  });
};
window.ProductOptionsHelpers = class ProductOptionsHelpers {
  static arraysEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    let seen = {};
    a.forEach(v => {
      let key = typeof v + v;
      if (!seen[key]) {
        seen[key] = 0;
      }
      seen[key] += 1;
    });
    return b.every(v => {
      let key = typeof v + v;
      if (seen[key]) {
        seen[key] -= 1;
        return true;
      }
    });
  }
  static arrayWrapIndex(arr, index) {
    return +index % arr.length;
  }
  static arrayFirst(arr, limit) {
    return arr.slice(0, +limit);
  }
};
window.ProductOption = class ProductOption extends HTMLElement {
  constructor() {
    super();
    this.inputEl = this.querySelector('input[data-input]');
    this.labelEl = this.querySelector('label[data-label]');
    this.optionsRootEl = this.closest('product-options');
  }
  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.optionsRootEl.uncheckAllOptions(this.depth);
    this.dataset.checked = true;
    this.optionsRootEl.updateOptions();
    this.optionsRootEl.updateVariant();
    this.optionsRootEl.updateRowsFrom(this.depth);
    this.optionsRootEl.callOnchangeCallback();
  }
  connectedCallback() {
    this.depth = +this.dataset.depth;
    this.inputEl.style.userSelect = "none";
    this.inputEl.style.pointerEvents = "none";
    this.addEventListener('click', this.handleClick);
  }
  static observedAttributes = ['data-checked'];
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "data-checked":
        if (newValue === "true") {
          this.inputEl.checked = true;
        } else {
          this.inputEl.removeAttribute('checked');
        }
        break;
      default:
        break;
    }
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
};
window.ProductOptions = class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }
  initOptions() {
    this.optionEls = [];
    for (let i = 0; i < this.maxDepth + 1; i++) {
      this.optionEls[i] = Array.from(this.querySelectorAll(`product-option[data-depth="${i}"],product-option-select[data-depth="${i}"]`));
    }
    let colorNameKeys = Object.keys(window.murmel.theme_settings).filter(x => x.startsWith('color_name_x'));
    let colorPalette = {};
    window.murmel.color_palette.forEach(pair => {
      colorPalette[pair[0]] = "#" + pair[1];
    });
    colorNameKeys.forEach(colorNameKey => {
      let colorValueKey = colorNameKey.replace("name", "value");
      let colorName = window.murmel.theme_settings[colorNameKey].toLowerCase();
      let colorValue = window.murmel.theme_settings[colorValueKey];
      colorPalette[colorName] = colorValue;
    });
    Array.from(this.querySelectorAll(`product-option[data-color]`)).forEach(colorOption => {
      let searchValue = colorOption.dataset.value.trim().toLowerCase();
      let searchValueNoWhitespace = searchValue.replace(/\s/g, "");
      let foundColor = colorPalette[searchValue] || colorPalette[searchValueNoWhitespace] || searchValue;
      colorOption.style.setProperty("--color", foundColor);
    });
  }
  uncheckAllOptions(depth) {
    this.optionEls[depth].forEach(optionEl => {
      delete optionEl.dataset.checked;
    });
  }
  updateOptions() {
    this.options = [];
    this.optionsValues = [];
    for (let i = 0; i < this.maxDepth + 1; i++) {
      if (this.optionEls[i].length === 1 && this.optionEls[i][0].dataset.type === 'dropdown') {
        this.options[i] = this.optionEls[i][0];
        this.optionsValues[i] = this.options[i].dataset.value;
      } else {
        this.options[i] = this.optionEls[i].find(x => x.hasAttribute('data-checked'));
        this.optionsValues[i] = this.options[i].dataset.value;
      }
    }
  }
  updateVariant() {
    this.variant = this.variants.find(x => {
      return this._isArrayEqual(x.options, this.optionsValues);
    }) || false;
    this.available = this.variant ? this.variant.available : false;
  }
  updateRow(depth) {
    let availableSelf = false;
    let trimmedOptions = this.optionsValues.slice(0, Number(depth) + 1);
    this.optionEls[depth].forEach(optionEl => {
      if (optionEl.dataset.type === 'dropdown') {
        const selectOptionsEls = Array.from(optionEl.querySelectorAll('[data-select] [data-depth]'));
        selectOptionsEls.forEach(selectOptionEl => {
          trimmedOptions[depth] = selectOptionEl.value;
          availableSelf = !this.trimmedVariants[depth].filter(x => {
            return this._isArrayEqual(x.options, trimmedOptions);
          }).every(x => {
            return x.available == false;
          });
          selectOptionEl.dataset.available = availableSelf;
          selectOptionEl.disabled = !availableSelf;
        });
      } else {
        trimmedOptions[depth] = optionEl.dataset.value;
        availableSelf = !this.trimmedVariants[depth].filter(x => {
          return this._isArrayEqual(x.options, trimmedOptions);
        }).every(x => {
          return x.available == false;
        });
        optionEl.dataset.available = availableSelf;
      }
    });
  }
  updateRowsFrom(depth) {
    for (let i = depth; i < this.maxDepth + 1; i++) {
      this.updateRow(i);
    }
  }
  callOnchangeCallback() {
    this.onchangeCallback(this.available, this.variant, this.optionsValues, this.options);
  }
  connectedCallback() {
    this.variants = Array.from(JSON.parse(this.dataset.variants));
    this.onchangeCallback = window[this.dataset.onchange];
    this.maxDepth = Number(this.dataset.maxDepth);
    this.pickerType = this.dataset.pickerType;
    this.available = false;
    this.variant = false;
    this.options = [];
    this.optionsValues = [];
    this.trimmedVariants = [];
    for (let i = 0; i < this.maxDepth + 1; i++) {
      this.trimmedVariants[i] = this.variants.map(variant => {
        return {
          ...variant,
          options: variant.options.slice(0, i + 1)
        };
      });
    }
    this.initOptions();
    this.updateOptions();
    this.updateVariant();
    this.updateRowsFrom(0);
    this.callOnchangeCallback();
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }
  _isArrayEqual(a, b) {
    if (a.length !== b.length) return false;
    let seen = {};
    a.forEach(v => {
      let key = typeof v + v;
      if (!seen[key]) {
        seen[key] = 0;
      }
      seen[key] += 1;
    });
    return b.every(v => {
      let key = typeof v + v;
      if (seen[key]) {
        seen[key] -= 1;
        return true;
      }
    });
  }
};
class ProductOptionSelect extends HTMLElement {
  constructor() {
    super();
    this.selectEl = this.querySelector('select[data-select]');
    this.optionsRootEl = this.closest('product-options');
  }
  handleChange(event) {
    event.preventDefault();
    event.stopPropagation();
    this.optionsRootEl.uncheckAllOptions(this.depth);
    this.dataset.value = this.selectEl.value;
    this.optionsRootEl.updateOptions();
    this.optionsRootEl.updateVariant();
    this.optionsRootEl.updateRowsFrom(this.depth);
    this.optionsRootEl.callOnchangeCallback();
  }
  connectedCallback() {
    this.depth = Number(this.dataset.depth);
    this.addEventListener('change', this.handleChange);
  }
  static observedAttributes = ['data-value'];
  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case 'data-value':
        this.selectEl.value = newValue;
        break;
      default:
        break;
    }
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
  }
}
if (!customElements.get("product-options")) customElements.define("product-options", ProductOptions);
if (!customElements.get("product-option")) customElements.define("product-option", ProductOption);
if (!customElements.get("product-option-select")) customElements.define("product-option-select", ProductOptionSelect);